import { http } from './http.jsx';

export const userService = {
  // Get all users
  getUsers: (params = {}) => http.get('/api/admin/users', { params }),
  
  // Get single user
  getUser: (userId) => http.get(`/api/admin/users/${userId}`),
  
  // Create new user
  createUser: (data) => http.post('/api/admin/users', data),
  
  // Update user
  updateUser: (userId, data) => http.put(`/api/admin/users/${userId}`, data),
  
  // Delete user
  deleteUser: (userId) => http.delete(`/api/admin/users/${userId}`),
};
